import TiptapEditor from '../../components/admin/TiptapEditor';
import './AdmissionEditor.css';

export const AdmissionEditor = ({ content, onChange }) => (
  <div>
    <div className="section-title">Informasi PSB</div>
    <div className="form-group">
      <label className="form-label"> 
        <span className="label-text">Konten</span>
      </label>
      <div className="editor-container">
        <TiptapEditor
          value={content}
          onChange={onChange}
        />
      </div>
    </div>
  </div>
);
